var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 7.7l-2.8 4.9c-.3.5-.9.7-1.4.4l-.3-.2-4.6-2.6c-.2-.1-.4-.3-.5-.6-.1-.3 0-.5.1-.8.3-.5.9-.7 1.4-.4l3 1.7C18.5 9 17.8 7.9 17 7c-1.3-1.3-3.1-2-5-2s-3.6.7-5 2-2 3.1-2 5 .7 3.6 2 5c2.7 2.7 7.2 2.7 9.9 0 .4-.4 1-.4 1.4 0s.4 1 0 1.4c-1.7 1.7-4 2.6-6.3 2.6s-4.6-.9-6.4-2.6C3.9 16.7 3 14.4 3 12s.9-4.7 2.6-6.4S9.6 3 12 3s4.7.9 6.4 2.6c1.1 1.1 1.8 2.4 2.3 3.8l1.5-2.7c.3-.5.9-.6 1.3-.4.5.3.6.9.4 1.4z"
  })));
}

export default SvgIconRefresh;